import { Box } from '@mui/material';
import Lottie from 'lottie-react';
import React from 'react';
import { WsTypoVariants, WsTypography } from 'wisestep-base';

import starLoaderAnimation from '../../../../animations/Star Loader 2.json';

interface StarLoaderProps {
  size?: number;
}

const StarLoader: React.FC<StarLoaderProps> = ({ size = 100 }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      {/* Lottie Animation */}
      <Box
        sx={{
          width: size,
          height: size,
          marginBottom: 2,
        }}
      >
        <Lottie
          animationData={starLoaderAnimation}
          loop={true}
          autoplay={true}
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </Box>
      <WsTypography variant={WsTypoVariants.TITLE} bold>
        {'Generating...'}
      </WsTypography>

      <Box m={2} maxWidth="70%" textAlign="center" sx={{ wordBreak: 'break-word' }}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>
          {'Hold on tight for a few seconds while we work on our magic and generate response'}
        </WsTypography>
      </Box>
    </Box>
  );
};

export default StarLoader;
